import { stringify } from 'csv-stringify/sync'
import { GlobalPrice, Price, PriceDto } from 'api/dto/price'
import { Tradeshow } from 'api/dto/tradeshow'
import axios from 'config/axios'
import { environment } from 'config/environment'

/**
 * @desc make csv from given data
 * @param rows
 * @param filename
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const exportToCsv = <T extends Record<string, any>>(rows: T[], filename: string) => {
  if (!rows.length) {
    return
  }

  const csvContent = stringify(rows, {
    header: true,
    columns: Object.keys(rows[0]).map((key) => ({
      key,
      header: key,
    })),
  })

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

/**
 * @desc Exports active events (where today is between startDate and endDate) and their price lists to CSV
 * @param tradeshows - all tradeshows
 * @param globalPrices - all global prices (used to resolve amounts)
 */
export const exportActiveEventPricesToCsv = async (tradeshows: Tradeshow[], globalPrices: GlobalPrice[]) => {
  const currentYear = new Date().getFullYear()
  const activeTradeshows = tradeshows.filter((ts) => {
    const start = new Date(ts.startDate)
    const end = new Date(ts.endDate)
    return start.getFullYear() === currentYear || end.getFullYear() === currentYear
  })

  const rows: Record<string, any>[] = []

  for (const tradeshow of activeTradeshows) {
    const { data } = await axios.get<PriceDto[]>(`${environment.restApi.resourceUrl.tradeshows}/${tradeshow.id}/prices`)
    const prices = data.map((dto) => new Price(dto))

    for (const price of prices) {
      const globalPrice = globalPrices.find((gp) => gp.id === price.globalPriceId)
      rows.push({
        'Event Name (EN)': tradeshow.nameEn,
        'Event Name (FR)': tradeshow.nameFr,
        'Price Name (EN)': price.nameEn,
        'Price Name (FR)': price.nameFr,
        'Price Type': price.type,
        Amount: globalPrice?.amount ?? '',
        Currency: globalPrice?.currency?.toUpperCase() ?? '',
      })
    }
  }

  exportToCsv(rows, 'active-events-prices.csv')
}
